import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";

export const Route = createFileRoute("/_public/about")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("About Modern Fence Install \u2014 Non-Electric Fencing Experts", "The trusted name in non-electric, nearly invisible containment for dogs, deer, and gardens.", "/about", false),
  component: About,
});
